<template>
  <div>
    <div v-if="isLoading" class="text-center mt-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Загрузка...</span>
      </div>
    </div>
    <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
    <div v-else-if="authorInfo">
      <h1 class="mb-1">{{ authorInfo.user_name }}</h1>
      <p v-if="authorInfo.description" class="text-muted mt-2 mb-0">
        {{ authorInfo.description }}
      </p>
      <p
        v-if="authorInfo.resource_url && authorInfo.resource_name"
        class="mt-2 mb-0"
      >
        <a
          :href="authorInfo.resource_url"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="bi bi-link-45deg"></i> {{ authorInfo.resource_name }}
        </a>
      </p>
      <!-- <hr v-if="authorInfo.description || authorInfo.resource_url" /> -->
      <RecipeList
        :key="authorInfo.user_name"
        mode="author"
        :author-name="authorInfo.user_name"
        :show-search-mode-togle="false"
        :show-filters="false"
        search-mode="sql"
      />
    </div>
  </div>
</template>

<script>
import RecipeList from "../RecipeList.vue";

export default {
  name: "PageAuthor",
  components: {
    RecipeList,
  },

  data() {
    return {
      authorName: null,
      authorInfo: null, // Will hold the full author object
      isLoading: true,
      error: null,
    };
  },

  mounted() {
    this.handleRouteChange();
    window.addEventListener("hashchange", this.handleRouteChange);
  },

  beforeUnmount() {
    window.removeEventListener("hashchange", this.handleRouteChange);
  },

  methods: {
    async handleRouteChange() {
      if (!window.location.hash.startsWith("#/author/")) {
        return;
      }
      const parts = window.location.hash.split("/");
      const authorNameEncoded = parts[parts.length - 1];

      if (authorNameEncoded) {
        const newAuthorName = decodeURIComponent(authorNameEncoded);
        if (newAuthorName !== this.authorName) {
          this.authorName = newAuthorName;
          this.isLoading = true;
          this.error = null;
          this.authorInfo = null;
          try {
            const command = `userinfo.getByName/${encodeURIComponent(
              this.authorName
            )}`;
            const response = await this.sendCmd(command);
            this.authorInfo = JSON.parse(response);
          } catch (err) {
            this.error =
              err.message || "Не удалось загрузить информацию об авторе.";
            console.error("Failed to fetch author info:", err);
          } finally {
            this.isLoading = false;
          }
        }
      }
    },
  },
};
</script>
